import {
  ROUTE_ONBOARDING_INTRO,
  ROUTE_ONBOARDING_DNA,
  ROUTE_ONBOARDING_GENERAL,
  ROUTE_ONBOARDING_LIFESTYLE,
  ROUTE_ONBOARDING_DISEASES,
  ROUTE_ONBOARDING_ENVIRONMENT,
  ROUTE_ASSESSMENT_HOME,
  ROUTE_HEALTH_PROFILE,
  ROUTE_PCE_ONBOARDING_INTRO,
  ROUTE_PCE_ONBOARDING_DNA,
  ROUTE_PCE_ONBOARDING_GENERAL,
  ROUTE_PCE_ONBOARDING_SKINCARE,
  ROUTE_PATH_SELECTION,
  ROUTE_RETAIL_EXPERIENCE_CART,
} from 'routes';

export const requiresProfileRevisit = responseProfile => {
  if (responseProfile && responseProfile.last_modified) {
    const dateTimeEls = responseProfile.last_modified.split('T');
    if (dateTimeEls.length > 1) {
      const dateEls = dateTimeEls[0].split('-');
      if (dateEls.length > 2) {
        const dt = new Date(
          parseInt(dateEls[0], 10),
          parseInt(dateEls[1], 10) - 1,
          parseInt(dateEls[2], 10)
        );
        const diffTime = Math.abs(new Date() - dt);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays >= 45) {
          return true;
        }
      }
    }
  }

  return false;
};

export const getRedirectRoute = (
  userMetaData,
  showBasicQuestions,
  responseProfile
) => {
  if (userMetaData == null) {
    return null;
  }

  if (
    Object.keys(userMetaData).length === 0 ||
    userMetaData.onboarding == null ||
    !userMetaData.introSeen
  ) {
    return ROUTE_ONBOARDING_INTRO;
  } else {
    if (userMetaData.onboarding.onboardingFinished === true) {
      if (
        userMetaData &&
        userMetaData.updateSpareProfileDisplayed !== true &&
        requiresProfileRevisit(responseProfile)
      ) {
        return ROUTE_HEALTH_PROFILE;
      }

      return ROUTE_ASSESSMENT_HOME;
    } else if (
      userMetaData.onboarding.dnaFinished == null &&
      process.env.REACT_APP_HIDE_DNA_SECTION !== 'true'
    ) {
      return ROUTE_ONBOARDING_DNA;
    } else if (userMetaData.onboarding.generalFinished == null) {
      return ROUTE_ONBOARDING_GENERAL;
    } else if (userMetaData.onboarding.lifestyleFinished == null) {
      return ROUTE_ONBOARDING_LIFESTYLE;
    } else if (userMetaData.onboarding.diseasesFinished == null) {
      return ROUTE_ONBOARDING_DISEASES;
    } else if (userMetaData.onboarding.environmentFinished == null) {
      return ROUTE_ONBOARDING_ENVIRONMENT;
    } else if (userMetaData.onboarding.introFinished == null) {
      return ROUTE_ONBOARDING_INTRO;
    } else {
      return ROUTE_ASSESSMENT_HOME;
    }
  }
};

export const getRedirectRoutePce = userMetaData => {
  if (userMetaData == null) {
    return null;
  }

  if (
    Object.keys(userMetaData).length === 0 ||
    userMetaData.onboarding == null ||
    !userMetaData.introSeen
  ) {
    return ROUTE_PCE_ONBOARDING_INTRO;
  } else {
    if (userMetaData.onboarding.onboardingPceFinished === true) {
      return ROUTE_RETAIL_EXPERIENCE_CART;
    } else if (
      userMetaData.onboarding.dnaFinished == null ||
      (userMetaData.dnaUsageOption && userMetaData.dnaUsageOption === '1')
    ) {
      return ROUTE_PCE_ONBOARDING_DNA;
    } else if (userMetaData.onboarding.generalFinished == null) {
      return ROUTE_PCE_ONBOARDING_GENERAL;
    } else if (userMetaData.onboarding.pceSkinCareFinished == null) {
      return ROUTE_PCE_ONBOARDING_SKINCARE;
    } else {
      return ROUTE_PCE_ONBOARDING_INTRO;
    }
  }
};

export const getAppRedirectRoute = (path, userMetaData, responseProfile) => {
  if (path === 'spare') {
    return getRedirectRoute(userMetaData, false, responseProfile);
  } else if (path === 'pce') {
    return getRedirectRoutePce(userMetaData);
  } else return ROUTE_PATH_SELECTION;
};

export const reportsBottomNavigationOptions = {
  home: 'home',
  healthRisk: 'health-risk',
  dnaRisk: 'dna-risk',
  recommendations: 'recommendations',
  likelihood: 'likelihood-history',
};
